import "@radix-ui/themes/styles.css";
import './index.css';
import './App.css';
import Header from "./components/layout/Header";
import Navigation from "./components/layout/Navigation";
import Content from "./components/layout/Content";
import Footer from "./components/layout/Footer";
import Kontakt from "./kontakt/Kontakt";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Impressum from "./impressum/Impressum";
import Barrierefreiheit from "./barrierefreiheit/Barrierefreiheit";
import Datenschutz from "./datenschutz/Datenschutz";
import Login from "./login/Login";
import {Theme} from '@radix-ui/themes';
import MetaNavigation from "./components/layout/MetaNavigation";

function App() {
    return (
        <Theme accentColor="bisbokat" style={{
            fontFamily: "'Open Sans', sans-serif",
            "--default-font-family": "'Open Sans', sans-serif",
        }}>
            <BrowserRouter>
                <div className="container">
                    <MetaNavigation></MetaNavigation>
                    <Header></Header>
                    <Navigation></Navigation>
                    <Content>
                        <Routes>
                            <Route path="/*" element={<Login/>}/>
                            <Route path="/kontakt" element={<Kontakt/>}/>
                            <Route path="/impressum" element={<Impressum/>}/>
                            <Route path="/datenschutz" element={<Datenschutz/>}/>
                            <Route path="/barrierefreiheit" element={<Barrierefreiheit/>}/>
                        </Routes>
                    </Content>
                    <Footer></Footer>
                </div>
            </BrowserRouter>
        </Theme>
    );
}

export default App;
